import { render, staticRenderFns } from "./status_tabs.vue?vue&type=template&id=930100f0"
import script from "./status_tabs.vue?vue&type=script&lang=js"
export * from "./status_tabs.vue?vue&type=script&lang=js"
import style0 from "./status_tabs.vue?vue&type=style&index=0&id=930100f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports